import React from 'react';
import { Grid } from '@material-ui/core';
import intl from 'react-intl-universal';
import LabelValue from 'eymp-uicomps/components/LabelValue';

function NotesPres({ caseReportNote }) {
  return (
    <Grid item sm={12}>
      <Grid>
        <Grid className="header-wrap">
          <LabelValue value="NOTES" />
        </Grid>
        <Grid className="notes-block-wrapper">
          <p>{caseReportNote ? caseReportNote : intl.get('newDashboard.common.noItemtoDisplay')}</p>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default NotesPres;
